import React, { useEffect, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllCareersInquiryAsync, careersInquiryAction } from "../redux";
import CareersInquiryTable from "./hfdicareersinquiry_detail/hfdicareersinquiryTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useIsAccessAllow } from "../../users/redux";

export function HfdiCareersInquiry() {
  const dispatch = useDispatch();
  const searchCareersInquiryRef = useRef();
  const type = "CONTACT";
  const { refreshCareersInquiryList, searchBy, searchText } = useSelector(
    (state) => state.careersInquiry,
    shallowEqual
  );

  useEffect(() => {
    if (refreshCareersInquiryList) {
      dispatch(getAllCareersInquiryAsync(searchBy, searchText, type));
    }
    // eslint-disable-next-line
  }, [refreshCareersInquiryList]);

  const onSearchTextChange = (e) => {
    dispatch(careersInquiryAction.searchTextChange(e.target.value));
  };
  const isSearchAllow = useIsAccessAllow("inquirycareers.list");

  return (
    <>
      <Card>
        <CardHeader title="Careers Inquiry">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  {isSearchAllow && (
                    <div className="form-group mr-3 mb-1">
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control"
                        value={searchText}
                        autoComplete="off"
                        onChange={onSearchTextChange}
                        ref={searchCareersInquiryRef}
                      />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <CareersInquiryTable />
      </Card>
    </>
  );
}
